import {
  Container,
  ContainerInner,
  Heading,
  Paragraph,
  HeadingContainer,
  Logo,
} from './landing.styles';
import NextButton from '../NextButton';
import useBackendPath from '../../hooks/useBackendPath';

const Landing = () => {
  const { backendPath } = useBackendPath();

  return (
    <Container>
      <ContainerInner>
        <HeadingContainer>
          <Logo
            src={`${backendPath}/assets/images/icons/gogreen-logo-white.svg`}
          />
          <Heading>
            Sustainable Logistics. Simplified.
            <br />
            Decarbonization Assessment.
          </Heading>
        </HeadingContainer>
        <Paragraph>
          Sustainable logistics solutions can be a game changer for both global
          climate action and your business reputation.
        </Paragraph>
        <Paragraph>
          Take this assessment to determine how advanced your company is on the
          journey toward transport decarbonization.
        </Paragraph>
        <Paragraph>
          This assessment will only take a few minutes to complete.
        </Paragraph>
        <NextButton text="Let&rsquo;s Begin" />
      </ContainerInner>
    </Container>
  );
};

export default Landing;
